import { Save } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import useApi from "_api/index";
import TableReport from "components/Car/TableReport";
import { GradientButton } from "components/GradientButton";
import React, { useEffect } from "react";
import {
  formatCurrency2Digit,
  formatDateMonthYear,
} from "utils/helpers/format";

const InterestCars = () => {
  const [loading, setLoading] = React.useState(false);
  const [datas, setDatas] = React.useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await useApi.car_report.getCarInterest();
      console.log("response", response);
      if (response.response) {
        const { formattedOrderAccount } = response.response;
        console.log("formattedOrderAccount", formattedOrderAccount);
        setDatas(formattedOrderAccount);
      }
    } catch (error) {
      console.error("Error fetching interest cars data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          ดอกเบี้ย
        </Typography>
        <GradientButton
          sx={{
            px: 3,
            display: "flex",
            alignItems: "center",
            height: "48px",
          }}
          endIcon={<Save fontSize="medium" />}
        >
          ส่งออก Excel
        </GradientButton>
      </Box>

      <TableReport
        loading={loading}
        data={datas || []}
        columns={[
          {
            field: "id",
            label: "ลำดับ",
            render: (row, index) => index + 1,
          },
          {
            field: "created_date",
            label: "วัน เดือน ปี",
            width: 200,
            render: (row) => formatDateMonthYear(row.created_date),
          },
          {
            field: "order_code",
            label: "รหัสรายการ",
          },
          {
            field: "status",
            label: "สถานะ",
            render: (row) => (
              <Chip
                label={row.status === "interest" ? "ดอกเบี้ย" : "ค่าปรับ"}
                color={row.status === "interest" ? "primary" : "error"}
              />
            ),
          },
          {
            field: "balance",
            label: "ยอดเงิน",
            render: (row) => formatCurrency2Digit(row.balance),
          },
        ]}
        lastRow={{
          order_code: "รวมทั้งสิ้น",
          balance: formatCurrency2Digit(
            datas?.reduce((sum, item) => sum + Number(item.balance), 0) || 0
          ),
        }}
      />
    </Box>
  );
};

export default InterestCars;
